<!--
 * @FileDescription: 新增或编辑角色对话框
 * @Author: 陈文景
 * @Date: 2022-09-22 14:32:37
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog :title="`${title}角色`" :visible.sync="visible" :destroy-on-close="true" width="50%" :before-close="close">
    <div class="header">
      <el-form :inline="true" :model="form" :rules="rules" ref="form" size="medium" :label-width="`${labelWidth}px`">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>

        <el-form-item label="角色描述" prop="description">
          <el-input v-model="form.description" placeholder="请输入" />
        </el-form-item>

        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="form.status" />
        </el-form-item>
      </el-form>
    </div>

    <div class="body">
      <!-- 菜单权限 -->
      <div class="left-menu">
        <div class="left-menu-tips">一级/二级菜单权限</div>
        <el-tree ref="tree" :data="menus" show-checkbox node-key="id" :default-expanded-keys="defaultExpandedKeys" :props="defaultProps" />
      </div>

      <!-- 按钮权限 -->
      <div class="right-button">
        <!-- 按钮权限 - 暂时不做 -->
        <btn-permission-item v-if="false" :title="'测试1'" :permissions="permissions" :checkedPermission="checkedPermission" @checked="(value) => (checkedPermission = value)" />
      </div>
    </div>

    <template slot="footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button size="medium" type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from '@/api'
import BtnPermissionItem from './BtnPermissionItem.vue'

let form = {
  id: undefined, // 新增时不传(编辑时必传)
  name: undefined, // 角色名称
  description: undefined, // 角色描述
  type: 2, // 角色类型: 1.System 2.自定义角色
  status: false, // 角色状态: 1.正常 0.停用
  ifDelete: 0, // 逻辑删除标识: 0.未删除 1.已删除
  permissionIds: [] // 菜单权限ID集合
}

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '新增'
    }
  },
  components: {
    'btn-permission-item': BtnPermissionItem
  },
  data() {
    return {
      visible: false, // 控制对话框的显示与隐藏

      labelWidth: 80,

      // 角色信息表单对象
      form: { ...form },

      // 规则校验对象
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: ['change', 'blur'] }]
      },

      menus: [], // 菜单全选列表数据
      menusIds: [],
      tileMenus: [],
      defaultCheckedKeys: [], // 默认选中的节点
      defaultExpandedKeys: [], // 默认展开的节点
      defaultProps: {
        children: 'children',
        label: 'name'
      },

      permissions: [], // 按钮权限列表数据 - 暂时不做
      checkedPermission: [] // 已选的按钮权限列表数据 - 暂时不做
    }
  },
  methods: {
    /**
     * API 获取所有菜单列表
     */
    async getAllMenuPermissions() {
      let { data } = await API.getAllMenuPermissions()
      this.menus = data
      this.menusIds = []
      this.getMenusIds(this.menus)
    },
    // 获取最小一级ID
    getMenusIds(menus) {
      menus.forEach((menu) => {
        if (menu.children && menu.children.length) {
          this.getMenusIds(menu.children)
        } else {
          this.menusIds.push(menu.id)
        }
      })
    },

    /**
     * API 获取角色详情
     * @param {Number} roleId 角色ID
     */
    async getRoleDetail(roleId) {
      let { data } = await API.getRoleDetail({ roleId })
      this.form.id = data.id
      this.form.name = data.name
      this.form.description = data.description
      this.form.type = data.type
      this.form.status = data.status === 1 ? true : false
      this.form.ifDelete = data.ifDelete
      this.defaultCheckedKeys = []
      this.defaultExpandedKeys = []
      this.getRoleIds(data.permissions)
      let result = this.getDefaultKeys(this.menusIds, this.defaultCheckedKeys)
      this.$refs.tree.setCheckedKeys(result, false) // 设置默认选中的节点
    },
    // 获取最小一级ID
    getRoleIds(permissions) {
      permissions.forEach((item) => {
        if (item.children && item.children.length) {
          this.getRoleIds(item.children)
        } else {
          this.defaultCheckedKeys.push(item.id)
          this.defaultExpandedKeys.push(item.id)
        }
      })
    },
    // 比较两个的差别
    getDefaultKeys(menusIds, defaultCheckedKeys) {
      let ids = []
      menusIds.forEach((menuId) => {
        defaultCheckedKeys.forEach((checkedId) => {
          if (menuId === checkedId) {
            ids.push(checkedId)
          }
        })
      })
      return ids
    },

    /**
     * 显示对话框
     * @param {Object} payload 当前编辑的行信息
     */
    show(payload) {
      this.getAllMenuPermissions()
      // 编辑
      if (payload) {
        this.getRoleDetail(payload.id)
      }
      this.visible = true
    },

    /**
     * 保存按钮
     */
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false
        let parameter = { ...this.form }
        parameter.status = parameter.status ? 1 : 0
        let permissionIds = this.$refs.tree.getCheckedKeys(false) // 获取目前被选中的节点的key所组成的数组
        let ids = this.getParentId(permissionIds)
        parameter.permissionIds = [...new Set(ids)].filter(Boolean)
        let { code, message } = await API.addOrEditSystemRoles(parameter)
        if (code === 10000) {
          this.close()
          this.$emit('update')
          this.$message.success(message)
        } else {
          this.$message.error(message)
        }
      })
    },
    // 获取父级的ID
    getParentId(permissionIds) {
      let ids = []
      this.getTileMenus(this.menus)
      permissionIds.forEach((permissionId) => {
        this.tileMenus.forEach((menu) => {
          if (permissionId === menu.id) {
            ids.push(menu.parentId, menu.id)
          }
        })
      })
      return ids
    },
    getTileMenus(menus) {
      menus.forEach((menu) => {
        if (menu.children && menu.children.length) {
          this.getTileMenus(menu.children)
        }
        this.tileMenus.push({ id: menu.id, parentId: menu.parentId })
      })
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据的方法
     */
    clear() {
      this.form = { ...form }
      this.menus = []
      this.menusIds = []
      this.tileMenus = []
      this.$refs.form.resetFields()
      this.defaultCheckedKeys = []
      this.defaultExpandedKeys = []
      this.permissions = []
      this.checkedPermission = []
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input {
  width: 100%;
}

.body {
  display: flex;
  border: 1px solid #cdd4dd;
  border-radius: 4px;
  .left-menu,
  .right-button {
    padding: 15px;
    min-height: 380px;
    max-height: 580px;
    overflow-y: auto;
  }
  .left-menu {
    flex: 2;
    border-right: 1px solid #cdd4dd;
    .left-menu-tips {
      margin-bottom: 15px;
    }
  }
  .right-button {
    flex: 10;
  }
}
</style>
